import { memo as Memo } from 'react';

//* Components
import Text from 'components/common/Text';
import Image from 'components/common/Image';
import Video from 'components/common/Video';

//* Style
import TextWithFileStyle from './style';

const TextWithFile = Memo(({ className, text, file }) => {
	return (
		<TextWithFileStyle className={`${className || ''}`}>
			<div className={`textWithFileWrap`}>
				<div className={`col-50 textAddWrap`}>
					<Text
						className={`h4 gilroyMedium blackRussian uppercase`}
						text={text}
					/>
				</div>
				<div className={`col-50`}>
					{file.type === 'image' ? (
						<Image
							priority
							src={file.url}
							alt={file.alt}
						/>
					) : (
						<Video
							src={file.url}
							autoplay={true}
							loop={true}
						/>
					)}
				</div>
			</div>
		</TextWithFileStyle>
	);
});

export default TextWithFile;
